import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const DIRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnPostlista,
  rutinInfos.rtnDiarie,
  rutinInfos.rtnDokument,
  rutinInfos.rtnVisaPostlista,
  rutinInfos.rtnVisaDiarie,
  rutinInfos.rtnAdresser_HarUtgatt,
  rutinInfos.rtnOrgPersLok,
];

export default DIRutinMeny;
